//#region src/org_order_channel_state.ts
var OrgOrderChannelState = /* @__PURE__ */ function(OrgOrderChannelState) {
	OrgOrderChannelState["Draft"] = "draft";
	OrgOrderChannelState["Live"] = "live";
	return OrgOrderChannelState;
}(OrgOrderChannelState || {});
//#endregion
export { OrgOrderChannelState };

//# sourceMappingURL=org_order_channel_state.js.map